<template>
  <div v-if="isShow">
    <jd-dialog
      title="商品详情"
      :visible.sync="isShow"
      width="50%"
      append-to-body
      class="new-input-box"
      @close="handleClose"
    >
      <jd-table
        :tableData="goodsData"
        :tableInfo="goodsInfo"
        :loading="loading"
        :pageInfo="{ noShow: true }"
      >
        <template slot="goodsInfoSlot" slot-scope="scope">
          <div>
            <div>商品名称：{{ scope.row.skuName }}</div>
            <div>SKUID：{{ scope.row.skuId }}</div>
          </div>
        </template>
        <template slot="discountSlot" slot-scope="scope">
          <div>{{ scope.row.discount }} <span>折</span></div>
        </template>
        <template slot="reducePriceSlot" slot-scope="scope">
          <div>{{ scope.row.discountAmount }} <span>元</span></div>
        </template>

        <template slot="stockSlot" slot-scope="scope">
          <div>{{ scope.row.totalAmount }} <span>件</span></div>
        </template>

        <template slot="promotionPriceSlot" slot-scope="scope">
          <div>{{ scope.row.payPrice }} <span>元</span></div>
        </template>
      </jd-table>
      <div slot="footer" class="dialog-footer">
        <jd-button
          type="blue"
          @click="handleClose"
          >关闭</jd-button
        >
      </div>
    </jd-dialog>
  </div>
</template>
<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    goodsData: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      loading: false,
      goodsInfo: [
        {
          label: "商品信息",
          prop: "goodsInfo",
          slot: "goodsInfoSlot",
          minWidth: 160,
        },
        {
          label: "京东价",
          prop: "jdPrice",
          width: 120,
        },
        {
          label: "折扣",
          prop: "discount",
          slot: "discountSlot",
          minWidth: 120,
        },
        {
          label: "减价",
          prop: "reducePrice",
          slot: "reducePriceSlot",
          minWidth: 120,
        },
        {
          label: "优惠库存",
          prop: "stock",
          slot: "stockSlot",
          minWidth: 120,
        },
        {
          label: "促销价",
          prop: "promotionPrice",
          slot: "promotionPriceSlot",
          minWidth: 120,
        },
      ],
    };
  },
  methods: {
    handleClose() {
      this.$emit("update:isShow", false);
    },
  },
};
</script>
<style lang="scss" scoped></style>
